import { render, staticRenderFns } from "./CreateNewJob.vue?vue&type=template&id=18bbb78c&scoped=true"
import script from "./CreateNewJob.vue?vue&type=script&lang=js"
export * from "./CreateNewJob.vue?vue&type=script&lang=js"
import style0 from "./CreateNewJob.vue?vue&type=style&index=0&id=18bbb78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bbb78c",
  null
  
)

export default component.exports